import React from 'react'
import { useArtboardDetailPathname } from '../../hooks'
import * as Styles from './PrototypeViewArtboardIconLink.styles'
import { Tooltip } from '@sketch/components'

export function PrototypeViewArtboardIconLink() {
  const artboardDetailPathname = useArtboardDetailPathname()
  return (
    <Tooltip disableWhenTouchDevice placement="bottom" content="View Artboard">
      <Styles.LinkButton
        data-testid="view-artboard-button"
        to={artboardDetailPathname}
        aria-label="View Artboard"
      >
        <Styles.Icon />
      </Styles.LinkButton>
    </Tooltip>
  )
}
